type UserInfoField = {
  label: string;
  value: string;
  isLoading?: boolean;
};

type UserInfoFieldsGridProps = {
  fields: UserInfoField[];
};

export type { UserInfoField };

export const UserInfoFieldsGrid = ({ fields }: UserInfoFieldsGridProps) => (
  <div className="grid grid-cols-1 gap-x-8 gap-y-5 md:grid-cols-2">
    {fields.map((field) => (
      <div key={field.label} className="flex min-w-0 flex-col gap-1">
        <p className="subtitle-sm text-type-light">{field.label}</p>
        {field.isLoading ? (
          <div className="skeleton h-6 max-w-[16rem] animate-pulse" aria-hidden />
        ) : (
          <p className="paragraph-base text-type-common break-words">{field.value}</p>
        )}
      </div>
    ))}
  </div>
);
